import { render, staticRenderFns } from "./questions-new.vue?vue&type=template&id=75fb6715&scoped=true&"
import script from "./questions-new.vue?vue&type=script&lang=js&"
export * from "./questions-new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75fb6715",
  null
  
)

export default component.exports